import styled from 'styled-components';

import { ClientOnlyPortal } from 'shared/components';
import { toggleVisible } from 'styles/theme/animation';
import { useBoundingClientRect } from 'shared/hooks';

export const SearchFilterTooltip = ({ 'data-qa': dataQa, isVisible, text, triggerRef }) => {
  const { top, width, x } = useBoundingClientRect(triggerRef, isVisible);

  return (
    <ClientOnlyPortal selector="#main-page-layout">
      <SearchFilterTooltip.Tooltip
        $isVisible={isVisible}
        $top={top}
        $left={width + x}
        data-qa={dataQa}
      >
        {text}
      </SearchFilterTooltip.Tooltip>
    </ClientOnlyPortal>
  );
};

SearchFilterTooltip.Tooltip = styled.div<{
  $isVisible: boolean;
  $left: number;
  $top: number;
}>`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    background: ${({ theme }) => theme.navigation.backgroundColor};
    border: 1px solid ${({ theme }) => theme.navigation.borderColor};
    display: block;
    padding: 4px;
    position: fixed;
    top: ${({ $top }) => $top && `${$top + 8}px`};
    left: ${({ $left }) => $left && `${$left + 10}px`};
    white-space: nowrap;
    text-transform: none;
    opacity: 0;
    visibility: hidden;
    ${({ $isVisible }) => $isVisible && toggleVisible};
  }
`;
